




















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppArticleCard from '~/components/partials/App/AppArticleCard.vue';
import { GaTopPartsType } from '~/utils/ga';
import { ArticleCard, ArticleCategory, EditorProfile } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppArticleCard,
  },
  props: {
    items: {
      type: Array as PropType<ArticleCard[]>,
      required: true,
    },
    authors: {
      type: Array as PropType<EditorProfile[]>,
      default: () => [],
    },
    categories: {
      type: Array as PropType<ArticleCategory[]>,
      default: () => [],
    },
    cols: {
      type: Number,
      required: true,
    },
    gaPartsType: {
      type: String as PropType<GaTopPartsType>,
      default: null,
    },
    isFavButtonHidden: {
      type: Boolean,
      default: false,
    },
  },
});
